import { createBrowserRouter, Navigate } from 'react-router-dom'

import { AutoDeploymentPage } from '@/pages/auto-deploy'
import { DeploymentCreateSubPage } from '@/pages/auto-deploy/components/DeploymentCreateSubPage.tsx'
import { AutoScalingListPage } from '@/pages/auto-scaling'
import { ScalingCreateSubPage } from '@/pages/auto-scaling/components/ScalingCreateSubPage'
import { ScalingMonitorDetailSubPage } from '@/pages/auto-scaling/components/ScalingMonitorDetailSubPage'
import { NotFoundPage } from '@/pages/not-found'

import { AuthLayout } from './components/AuthLayout'
import { Layout } from './components/Layout'
import { PaymentCallbackLayout } from './components/PaymentCallbackLayout'
import { BillingPage } from './pages/billing'
import { CreateInstancePage } from './pages/create-instance'
import { DataMgrPage } from './pages/data-mgr'
import { DevPage } from './pages/dev'
import { ErrorPage } from './pages/error'
import { InstanceListPage } from './pages/instance-list'
import { InstanceMonitorDetailSubPage } from './pages/instance-list/components/InstanceMonitorDetailSubPage'
import { InvoicePage } from './pages/invoice'
// import { LoginPage } from './pages/login'
import { LoginPage as WalletLoginPage } from './pages/login-web3'
import { MeshClusteringListPage } from './pages/mesh-clustering'
import { PaypalPaymentCallbackPage } from './pages/payment/paypal/callback'
import { PaypalPaymentCancelPage } from './pages/payment/paypal/cancel'
import { ProfilePage } from './pages/profile'
import { RegisterPage } from './pages/register'
import { SnapshotListPage } from './pages/snapshots'
import { SpaceMgrPage } from './pages/space-mgr'
import { Root } from './Root'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '',
        element: <Layout />,
        children: [
          { path: '', element: <Navigate to="/create" replace /> },
          { path: '/create', element: <CreateInstancePage /> },
          { path: '/instances', element: <InstanceListPage /> },
          { path: '/instances/monitor', element: <InstanceMonitorDetailSubPage /> },
          { path: '/data', element: <DataMgrPage /> },
          { path: '/scaling', element: <AutoScalingListPage /> },
          { path: '/deploy', element: <AutoDeploymentPage /> },
          { path: '/deploy/create', element: <DeploymentCreateSubPage /> },
          { path: '/scaling/create', element: <ScalingCreateSubPage /> },
          { path: '/scaling/monitor', element: <ScalingMonitorDetailSubPage /> },
          { path: '/snapshots', element: <SnapshotListPage /> },
          { path: '/mesh', element: <MeshClusteringListPage /> },
          { path: '/space', element: <SpaceMgrPage /> },
          { path: '/billing', element: <BillingPage /> },
          { path: '/invoice', element: <InvoicePage /> },
          { path: '/profile', element: <ProfilePage /> },
        ],
      },
      {
        path: '',
        element: <AuthLayout />,
        children: [
          {
            path: '/login',
            element: <WalletLoginPage />,
          },
          // {
          //   path: '/login-web3',
          //   element: <WalletLoginPage />,
          // },
          {
            path: '/register',
            element: <RegisterPage />,
          },
        ],
      },
      {
        path: '',
        element: <PaymentCallbackLayout />,
        children: [
          {
            path: '/payment/callback/paypal',
            element: <PaypalPaymentCallbackPage />,
          },
          {
            path: '/payment/callback/paypal_cancel',
            element: <PaypalPaymentCancelPage />,
          },
        ],
      },
      { path: '*', element: <NotFoundPage /> },
      import.meta.env.DEV && {
        path: 'dev',
        element: <DevPage />,
      },
    ].filter(Boolean) as any,
  },
])
